const users = {
  users: {
    pageHeader: 'Users',
    addNewUser: '+ Add New User',
    name: 'Name',
    role: 'Role',
    company: 'Company',
    status: 'Status',
    noUser: '** No Users Available **',
    emailMatch: 'Please enter the same value again.',
    validEmail: 'Please enter a valid email address.',
    fieldRequired: 'This field is required.',
    userFormHeader: 'Add New Users',
    userProfile: 'User Profile',
    defaultEmailHelpText: 'An email explaining how to sign in will be sent to this address.',
    active: 'Active',
    email: 'Email',
    confirmEmail: 'Confirm Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    phoneNumber: 'Phone Number',
    preferredLocale: 'Preferred Locale',
    units: 'Units',
    addUser: 'Add User',
    updateUser: 'Update User',
    supportTechnician: 'Support Technician',
    profileAdministrator: 'Profile Administrator',
    profileApprover: 'Profile Approver',
    administrator: 'Administrator',
    user: 'User',
    viewOnly: 'View Only',
    demonstration: 'Demonstration',
    errorMessageLengthPhone: 'Maximum of 50 characters allowed',
    all: 'All',
    inactive: 'Inactive',
    termsAndServices: 'Only the system owner may provide access to their site. Without written approval from the system owner, installers may not provide access to other companies and may not provide access to users outside of their company. I have read and agree to Enphase’s %{termsService} and have read Enphase’s %{privacyPolicy}. I understand that violation of these conditions may result in suspension or termination of my Enlighten account.',
    privacyPolicy: 'Privacy Policy',
    termsService: 'Terms of Service',
  }
};

export default users;
